import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enLang from "../../core/utils/languages/locales/en/translation.json";
import frLang from "../../core/utils/languages/locales/fr/translation.json";

i18n.use(initReactI18next).init({
  fallbackLng: "en",
  resources: {
    en: { translation: enLang },
    fr: { translation: frLang },
  },
  interpolation: { escapeValue: false },
});

export default i18n;
